import { render, staticRenderFns } from "./Chefs.vue?vue&type=template&id=a79524d8&scoped=true&"
import script from "./Chefs.vue?vue&type=script&lang=js&"
export * from "./Chefs.vue?vue&type=script&lang=js&"
import style0 from "./Chefs.vue?vue&type=style&index=0&id=a79524d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79524d8",
  null
  
)

export default component.exports